import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "min-h-screen flex flex-col bg-gray-200"
}
const _hoisted_2 = { class: "flex-grow bg-gradient-to-br from-[#2BADBD] via-[#259BAA] to-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterSection = _resolveComponent("FooterSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-2 bg-[#249c38]" }, null, -1)),
    _createVNode(_component_FooterSection)
  ]))
}